(() => {
  const root = document.getElementById('rok-waste-fit');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  document.body.classList.add('rwf-page');
  const t = JSON.parse(root.querySelector('[data-rwf-translations]').textContent);
  const dialog = root.querySelector('dialog');
  const select = root.querySelector('#rwf-model');
  const query=new URLSearchParams(location.search);
  const output = root.querySelector('.rwf-model-details');
  let active;
  const el = (tag, text, cls) => { const n = document.createElement(tag); if(text) n.textContent=text; if(cls)n.className=cls; return n; };
  const showModel = () => {
    const m=active.models.find(m=>m.id===select.value);
    if(!m)return;
    output.replaceChildren();
    if(m.nominal){output.append(el('h3',t.nominal),el('p',m.nominal));}
    output.append(el('p',m.sku));
    if(!m.requirements.some(r=>r.w&&r.widthLabel!=='Inside width'))output.append(el('p','Opening width: not supplied. Confirm the required clear opening before ordering.','rwf-note'));
    if(m.productDimensions){
      output.append(el('h3','Overall product dimensions'));
      const dims=el('div',null,'rwf-measures');
      for(const [label,key]of [['Product width','w'],['Product depth','d'],['Product height','h']]){const cell=el('div');cell.append(el('span',label),el('strong',m.productDimensions[key]||'Not supplied'));dims.append(cell);}
      output.append(dims,el('p','These are product dimensions, not the required cabinet opening.'));
    }
    for(const r of m.requirements){
      output.append(el('h3',`${t.required} — ${r.type}`));
      const dims=el('div',null,'rwf-measures');
      for(const [label,value]of [[r.widthLabel==='Inside width'?t.inside:t.width,r.w],[t.depth,r.d],[t.height,r.h]]){const cell=el('div');cell.append(el('span',label),el('strong',value||'—'));dims.append(cell);}
      output.append(dims);
      if(r.inside)output.append(el('p',`${t.inside}: ${r.inside}`));
      if(!r.w||!r.d||!r.h)output.append(el('p',t.unknown,'rwf-note'));
    }
    if(m.note)output.append(el('p',m.note));
    output.append(el('p',t.final_check,'rwf-note'));
    const link=el('a',t.view);link.href=m.url;output.append(link);
    if(m.instructions){const a=el('a',t.instructions);a.href=m.instructions;a.target='_blank';a.rel='noopener';output.append(a);}
    output.append(window.ROKOrganizerCart.create([m]));
  };
  select.addEventListener('change',showModel);
  root.querySelector('.rwf-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  fetch(root.dataset.fitUrl).then(r=>{if(!r.ok)throw Error('Fit data unavailable');return r.json();}).then(data=>{
    const enhance=()=>{
      document.querySelectorAll('.snize-product-filters-title').forEach(title=>{
        if(['Cabinet size (outside width)'].includes(title.textContent.trim()))(title.closest('.snize-product-filters-block')||title.closest('.snize-product-filters-header')||title.parentElement).classList.add('rwf-legacy-fit-filter');
      });
      document.querySelectorAll('.snize-product').forEach(card=>{
        if(card.querySelector('.rwf-card'))return;
        const a=card.querySelector('a[href*="/products/"]');if(!a)return;
        const url=new URL(a.href,location.origin);const handle=url.pathname.split('/products/')[1]?.split('/')[0];let p=data[handle];if(!p)return;
        if(window.rokWasteFitSearch?.active){p={...p,models:p.models.filter(m=>window.rokWasteFitSearch.variants.includes(m.id))};if(!p.models.length)return;}
        let cardModels=p.models;
        if(window.rokWasteFitSearch?.active){
          const current=url.searchParams.get('variant');
          const shown=p.models.find(m=>m.id===current)||p.models[0];
          cardModels=[shown];
          const productTitle=card.querySelector('.snize-title')?.textContent || p.title;
          card.classList.add('rwf-model-card');card.dataset.rwfVariant=shown.id;
          card.querySelectorAll('a[href*="/products/"]').forEach(link=>{link.href=shown.url;link.setAttribute('aria-label',productTitle);});
          const desc=card.querySelector('.snize-description');if(desc)desc.textContent=shown.sku?'SKU: '+shown.sku:'';
          const img=card.querySelector('.snize-item-image:not(.snize-flip-image)');
          if(img&&shown.image){img.src=shown.image;img.removeAttribute('srcset');img.alt=productTitle;}
          const price=card.querySelector('.snize-price');
          if(price&&(!window.Shopify?.currency?.active||window.Shopify.currency.active==='USD'))price.textContent=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(+shown.price);
          card.querySelectorAll('.snize-discounted-price,.snize-save-price-wrapper,.snize-visually-hidden').forEach(n=>n.remove());
          url.searchParams.set('variant',shown.id);
        }
        const desc=card.querySelector('.snize-description');
        if(desc)desc.textContent=cardModels.length===1?(cardModels[0].sku?'SKU: '+cardModels[0].sku:''):t.multiple_models;
        const box=el('div',null,'rwf-card');
        const openModels=()=>{active=p;root.querySelector('#rwf-dialog-heading').textContent=p.title;select.replaceChildren(...p.models.map(m=>{const o=el('option',m.title+' — '+m.sku);o.value=m.id;return o;}));const variant=url.searchParams.get('variant');if(p.models.some(m=>m.id===variant))select.value=variant;showModel();dialog.showModal();};
        const cart=window.ROKOrganizerCart.create(cardModels,openModels);
        const openings=cardModels.flatMap(m=>m.requirements.filter(r=>r.w&&r.widthLabel!=='Inside width').map(r=>parseFloat(r.w))).filter(Number.isFinite);
        if(cardModels.length===1&&openings.length){
          const smallest=Math.min(...openings);
          const varies=new Set(openings).size>1;
          const line=el('p');line.append(el('span','Opening: '),el('strong',(varies?'from ':'')+smallest+'″ wide'));box.append(line);
        }else if(cardModels.length>1&&openings.length)box.append(el('p','Opening: varies by model'));
        else{
          box.append(el('p','Opening: not supplied'));
          if(cardModels.length===1){
            const m=cardModels[0];const inside=m.requirements.find(r=>r.widthLabel==='Inside width'&&r.w);
            if(inside)box.append(el('p','Inside cabinet width: '+inside.w));
            else if(m.productDimensions?.w)box.append(el('p','Product width: '+m.productDimensions.w));
          }
        }
        if(!cardModels.some(m=>m.requirements.length||m.productDimensions)){
          const link=el('a','View product details');link.href=url.href;box.append(link);card.append(box,cart);return;
        }
        const btn=el('button',t.check);btn.type='button';
        if(!openings.length)btn.textContent='View size details';
        btn.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();active=p;root.querySelector('#rwf-dialog-heading').textContent=p.title;select.replaceChildren(...p.models.map(m=>{const o=el('option',m.title);o.value=m.id;return o;}));const variant=url.searchParams.get('variant');if(p.models.some(m=>m.id===variant))select.value=variant;showModel();dialog.showModal();});
        box.append(btn);card.append(box,cart);
      });
    };
    let queued=false;
    const observer=new MutationObserver(()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;enhance();});}});
    observer.observe(document.getElementById('root')||document.body,{childList:true,subtree:true});enhance();
  }).catch(()=>{});
})();